import { observer } from 'mobx-react-lite'
import { MenuSearch } from 'shared/ui'
import { useContactsMenuContext } from 'pages/contacts/ui/ContactsMenu/context/contactsMenuContext'

export const Search = observer(() => {
  const { search, setSearch } = useContactsMenuContext()

  return <MenuSearch search={search} onSearch={setSearch} />
})
